import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const RejectItemModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "RejectItemModalContainer" */
      './RejectItemModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
